import image1 from '../../../../assets/Carousel_2_1.png';
import image2 from '../../../../assets/Carousel_2_2.png';
import image3 from '../../../../assets/Carousel_2_3.png';

export const slidesNewArrival: { image: string, title: string, info: string }[] = [
  {
    image: image1,
    title: "Men's Trail Runner SWT",
    info: 'Classic Color, Natural Black',
  },
  {
    image: image2,
    title: "Women's Trail Runner SWT",
    info: 'Classic Color, Natural White',
  },
  {
    image: image3,
    title: "Men's Trail Runner SWT",
    info: 'Limited Edition Color, Diablo',
  },
  {
    image: image1,
    title: "Men's Trail Runner SWT",
    info: 'Classic Color, Natural Black',
  },
  {
    image: image2,
    title: "Women's Trail Runner SWT",
    info: 'Classic Color, Natural White',
  },
  {
    image: image3,
    title: "Men's Trail Runner SWT",
    info: 'Limited Edition Color, Diablo',
  },
];
